import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function UserAuth0({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Users Logs'}  email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

